import React from 'react';
import { useData } from '../../../contexts';
import { DataGrid } from '@mui/x-data-grid';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { BarChartComparissonSimple } from '../../BarChart/BarChart';

export const EvolutiescoreRegisterTable = (props: any) => {
  const { data, keysInStack, colorsBar } = props;
  const {
    deltaColors,
    selectedGemeente,
    selectedBenchmarks,
    setRadarIdToHighlight,
    locale,
  } = useData();

  const columns: GridColDef[] = [
    {
      headerName: <></>,
      flex: 1,
      minWidth: 0,
      renderCell: (params: any) => {
        return <></>;
      },
    },
    {
      field: 'label',
      headerName: 'Indicator',
      width: 180,
      align: 'left',
      renderCell: (params: any) => {
        const out = params.row.detail
          ? params.row.detail.ratio === '%'
            ? '(procent)'
            : params.row.detail.ratio === null ||
              params.row.detail.ratio === undefined ||
              params.row.detail.ratio === ''
            ? `(${params.row.detail.eenheid})`
            : `(${params.row.detail.eenheid} ${params.row.detail.ratio})`
          : '-';
        return (
          <Tooltip>
            <TooltipTrigger>
              <div style={{ textAlign: 'left' }}>
                <p style={{ marginBottom: '2px' }} title={params.row.label}>
                  {params.row.label}{' '}
                  {/* <span style={{ color: '#888' }}>{out}</span> */}
                </p>
                <p style={{ color: '#888' }}>{out}</p>
              </div>
            </TooltipTrigger>
            <TooltipContent className="Tooltip">
              <p>
                {params.row.detail
                  ? params.row.definitie
                  : 'Definitie ontbreekt'}
              </p>
            </TooltipContent>
          </Tooltip>
        );
      },
    },

    // {
    //   field: 'delta',
    //   headerName: 'Delta',
    //   width: 60,
    //   type: 'number',
    //   renderCell: (row: any) => {
    //     const out =
    //       row.value > 0
    //         ? '+' + locale.format('.1%')(row.value)
    //         : locale.format('.1%')(row.value);

    //     const color = row.value > 0 ? deltaColors[0] : deltaColors[1];
    //     return <p style={{ color: color }}>{out}</p>;
    //   },
    // },

    {
      field: 'deltaAbs',
      headerName: 'deltaAbs',
      width: 80,
      type: 'number',
      renderCell: (row: any) => {
        const out =
          row.value > 0
            ? '+' + locale.format(row.row.d3format)(row.value)
            : locale.format(row.row.d3format)(row.value);

        const color = row.value > 0 ? deltaColors[0] : deltaColors[1];
        return <p style={{ color: color }}>{out}</p>;
      },
    },

    {
      field: 'valueReal',
      headerName: (
        <>
          <Tooltip>
            <TooltipTrigger>
              <p>{selectedGemeente.label}</p>
            </TooltipTrigger>
            <TooltipContent className="Tooltip">
              <p>{selectedGemeente.label}</p>
            </TooltipContent>
          </Tooltip>
        </>
      ),
      width: 90,
      type: 'number',
      renderCell: (params: any) => {
        const tt = params.row.detail
          ? params.row.detail.ratio === '%'
            ? '(procent)'
            : '(' +
              params.row.detail.eenheid +
              ' ' +
              params.row.detail.ratio +
              ')'
          : '-';

        let out = '';
        if (params.row.valueReal === null) {
          out = '-';
        } else {
          out = `${locale.format(params.row.d3format)(params.row.valueReal)} (${
            params.row.jaar
          })`;
        }
        return (
          <>
            <Tooltip>
              <TooltipTrigger>
                <p style={{ color: colorsBar[0] }}>{out}</p>
              </TooltipTrigger>
              <TooltipContent className="Tooltip">
                <p style={{ marginBottom: '2px' }} title={params.row.label}>
                  {params.row.label}{' '}
                </p>
                <p>{tt}</p>
              </TooltipContent>
            </Tooltip>
          </>
        );
      },
    },

    {
      field: 'valueRealVorig',
      headerName: (
        <>
          <Tooltip>
            <TooltipTrigger>
              <p>{selectedGemeente.label + ' (vorig)'}</p>
            </TooltipTrigger>
            <TooltipContent className="Tooltip">
              <p>{selectedGemeente.label + ' (vorig)'}</p>
            </TooltipContent>
          </Tooltip>
        </>
      ),
      width: 90,
      type: 'number',
      renderCell: (params: any) => {
        const tt = params.row.detail
          ? params.row.detail.ratio === '%'
            ? '(procent)'
            : '(' +
              params.row.detail.eenheid +
              ' ' +
              params.row.detail.ratio +
              ')'
          : '-';

        let out = '';
        if (params.row.valueRealVorig === null) {
          out = '-';
        } else {
          out = `${locale.format(params.row.d3format)(
            params.row.valueRealVorig,
          )} (${params.row.jaarVorig})`;
        }
        return (
          <>
            <Tooltip>
              <TooltipTrigger>
                <p style={{ color: colorsBar[1] }}>{out}</p>
              </TooltipTrigger>
              <TooltipContent className="Tooltip">
                <p style={{ marginBottom: '2px' }} title={params.row.label}>
                  {params.row.label}{' '}
                </p>
                <p>{tt}</p>
              </TooltipContent>
            </Tooltip>
          </>
        );
      },
    },
    {
      headerName: <></>,
      flex: 1,
      minWidth: 0,
      renderCell: (params: any) => {
        return <></>;
      },
    },
  ];

  const renderBarChart = (
    props: any,
    idField: any,
    scatterShartOneDimensionalProps: any[],
  ) => {
    const { row } = props;
    const arr = [row];

    return (
      <BarChartComparissonSimple
        data={arr}
        keysInStack={keysInStack}
        colors={colorsBar}
        locale={locale}
        survey={data?.detail?.survey === '0' ? false : true}
        legend={false}
        labels={[data[0].jaar, data[0].jaarVorig]}
      />
    );
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    // const field = event.currentTarget.dataset.field!;
    const id = event.currentTarget.parentElement!.dataset.id!;

    const row = data.find((d: any) => parseInt(d.id) === parseInt(id))!;
    const label = row !== undefined && row.label !== undefined ? row.label : '';

    setRadarIdToHighlight(label);
  };

  const handleMouseLeave = () => {
    setRadarIdToHighlight();
  };

  const getDensity = () => {
    const density =
      data !== undefined && data.length > 9 ? 'standard' : 'standard';
    return density;
  };

  return (
    <DataGrid
      rows={data}
      columns={columns}
      hideFooter={true}
      density={getDensity()}
      rowHeight={60}
      disableColumnMenu
      disableRowSelectionOnClick
      slots={{
        columnHeaders: () => null,
      }}
      slotProps={{
        cell: {
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
        },
      }}
      sx={{
        fontSize: '11px',
        boxShadow: 0,
        border: 0,
        backgroundColor: '#FFF',
        '& .MuiDataGrid-columnHeader:focus': {
          outline: 'none',
        },
        '& .MuiDataGrid-cell': {
          cursor: 'pointer',
          border: 'none',
          outline: 'none',
          '&:focus': {
            outline: 'none',
          },
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
          width: '0.8em',
          height: '0.8em',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
          background: '#555',
        },
        '& .MuiDataGrid-virtualScroller': {
          // scrollbarColor: 'red blue',
          scrollbarWidth: 'thin',
        },
      }}
    />
  );
};
